import { Navigate } from "react-router-dom";
import { useVLETools, VLEToolKey } from "@/hooks/useVLETools";
import { DashboardSkeleton } from "@/components/ui/LoadingSkeleton";

interface ToolRouteGuardProps {
  toolKey: VLEToolKey;
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * Route guard that checks if the specific tool is enabled for the current VLE.
 * Subscription checks removed — all bridge users have active access.
 */
export function ToolRouteGuard({ 
  toolKey, 
  children, 
  redirectTo = "/dashboard" 
}: ToolRouteGuardProps) {
  const { isToolEnabled, isLoading: toolsLoading } = useVLETools();

  if (toolsLoading) {
    return (
      <div className="flex h-screen items-center justify-center p-6 bg-background">
        <DashboardSkeleton />
      </div>
    );
  }

  // Check if tool is enabled
  if (!isToolEnabled(toolKey)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
